<template>
  <div class="level is-flex-direction-column">
    <div class="level-right ml-auto">
      <p class="level-item">
        <b-select
          :value="filters.liveCategoryId"
          placeholder="Choisir une catégorie"
          @input="$emit('update:filters', { ...filters, liveCategoryId: $event })"
        >
          <option :value="null">Choisir une catégorie</option>
          <option v-for="category in categories" :key="category.id" :value="category.id">
            {{ category.name }}
          </option>
        </b-select>
      </p>
    </div>
    <div class="level-right ml-auto">
      <p class="level-item">
        <b-button
          v-show="showClearFilterButton"
          class="is-small"
          type="is-text"
          @click="$emit('clear')"
        >
          Supprimer les filtres
        </b-button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QueclinkTrackerConfigFilter',

  props: {
    filters: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
  },

  computed: {
    showClearFilterButton() {
      return Object.values(this.filters).some((filter) => filter !== null)
    },
  },
}
</script>
